import { useSelector } from "react-redux";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";
import Forgot from "../Auth/Forgot";
import Login from "../Auth/Login";
import Verify from "../Auth/Verify";
import Loader from "../Components/Loader/Loader";
import Landing from "../Pages/Landing";
import Dashboard from "../Pages/SidebarPages/Dashboard/Dashboard";
import CreateUser from "../Auth/CreateUser";
import Categories from "../Pages/SidebarPages/category/Categories";
import PrivacyPolicy from "../Pages/PrivacyPolicy";

function PublicRoute({ isAuthenticated }) {
  if (isAuthenticated) return <Navigate to="/feeds" replace />;
  return <Outlet />;
}

function PrivateRoute({ isAuthenticated }) {
  if (!isAuthenticated) return <Navigate to="/" replace />;
  return <Outlet />;
}

export default function AdminRoutes() {
  const token = useSelector((state) => state?.Authlogin?.data?.uid);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="privacy-policy" element={<PrivacyPolicy />} />
        <Route element={<PublicRoute isAuthenticated={token} />}>
          <Route element={<Login />} path="/" />
          <Route element={<Verify />} path="verify" />
          <Route element={<Forgot />} path="/forgot" />
          <Route element={<Loader />} path="/loader" />
          <Route element={<CreateUser />} path="/create-user" />
        </Route>
        <Route element={<PrivateRoute isAuthenticated={token} />}>
          <Route element={<Landing />} path="/">
            <Route element={<Dashboard />} path="/feeds" />
            <Route element={<Categories />} path="/categories" />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
